import { ReactNode, useEffect, useMemo, useState } from 'react';
import { ReactComponent as ChevroneDown } from '@Icons/additional/chevrone-down.svg';
import { Drawer, DrawerProps } from 'antd';

import { OptionExtended } from '@Components/types/options';

import { MobileDrawer } from '../MDrawer';
import DrawerItems from './components/DrawerItems';
import styles from './select-drawer.module.css';

interface SelectDrawerProps extends DrawerProps {
  caption: string;
  title: string;
  items?: OptionExtended[];
  name?: string;
  handleSelect?: (label: string, value: string | null) => void;
  children?: ReactNode;
  onOpen?: () => void;
  showCounter?: boolean;
  mobileView?: boolean;
}

const SelectDrawer: React.FC<SelectDrawerProps> = (props) => {
  const [open, setIsOpen] = useState(false);
  const {
    caption,
    children,
    title,
    handleSelect,
    items,
    onOpen,
    showCounter = false,
    mobileView = false,
    name,
  } = props;

  useEffect(() => {
    if (open) {
      onOpen?.();
    }
  }, [open, onOpen]);

  const onClick = (): void => {
    setIsOpen(true);
  };

  const onClose = (): void => {
    setIsOpen(false);
  };

  const renderChildrenDrawer = useMemo(() => {
    if (children) return children;

    if (items && handleSelect) {
      const handleDrawItemOnClick = (
        label: string,
        value: string | null
      ): void => {
        onClose();
        handleSelect(label, value);
      };

      return (
        <DrawerItems
          selectedRequest={caption}
          items={items}
          onClick={handleDrawItemOnClick}
          showCounter={showCounter}
          mobileView={mobileView}
          name={name}
        />
      );
    }

    return null;
  }, [children, items, handleSelect, caption]);

  return (
    <div className={styles.selectDrawer}>
      <div className={styles.selectRequestTypeCaption} onClick={onClick}>
        {caption} <ChevroneDown className={styles.chevroneButton} />
      </div>
      {mobileView ? (
        <MobileDrawer
          className={mobileView ? styles.selectMobileView : ''}
          open={open}
          onClose={onClose}
          {...props}
          title={title}
        >
          {renderChildrenDrawer}
        </MobileDrawer>
      ) : (
        <Drawer
          className={styles.drawer}
          open={open}
          onClose={onClose}
          {...props}
          title={title}
          width={410}
        >
          {renderChildrenDrawer}
        </Drawer>
      )}
    </div>
  );
};

export default SelectDrawer;
